//IMPORTS
import NavBar from "./navBar";

export const pods = {
    navBar: NavBar
};
